import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    show() {
        this.element.querySelector('.info-box').classList.remove('d-none');
        this.element.querySelector('.info-outline').classList.add('d-none');
    }

    hide() {
        this.element.querySelector('.info-box').classList.add('d-none');
        this.element.querySelector('.info-outline').classList.remove('d-none');
    }
}
